export const selectReducer = (state) => state.legal;

export const selectLegalLanguageCode = (state) =>
  selectReducer(state) ? selectReducer(state).get('languageCode') : '';
